const ShareSummaryTable = ({
  summaryData = [],
  registerData = [],
  showAction = true,
  onAddShare,
}) => {
  if (summaryData.length === 0) return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 text-center">
                      {/* <FiFile className="h-12 w-12 text-gray-500 mx-auto mb-4" /> */}
                      <h3 className="text-lg font-medium text-gray-900 mb-2">
                          No MGT-1 FIlled
                      </h3>
                      <p className="text-gray-600 mb-4">
                          This share summary doest not exist.
                      </p>
                  </div>
  );

  

  const val = (v) =>
    v !== null && v !== undefined && v !== "" ? String(v) : "-";

  const totalShares = summaryData.reduce(
    (sum, r) => sum + (Number(r.numberOfShares) || 0),
    0,
  );

  return (
    <div className="mt-1 w-full flex justify-center">
      <div className="w-full bg-white rounded-lg shadow-md p-3">
        <h3 className="text-base font-bold text-gray-800 mb-2 text-left">
          Share Summary – All Folios
        </h3>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-sm">
            <thead>
              <tr className="bg-gray-200">
                <th className="border border-gray-400 px-2 py-2 text-center font-semibold">
                  #
                </th>
                <th className="border border-gray-400 px-2 py-2 text-center font-semibold">
                  Folio No.
                </th>
                <th className="border border-gray-400 px-2 py-2 text-left font-semibold">
                  Member Name
                </th>
                <th className="border border-gray-400 px-2 py-2 text-left font-semibold">
                  Joint Holder
                </th>
                <th className="border border-gray-400 px-2 py-2 text-right font-semibold">
                  No. of Shares
                </th>
                {showAction && (
                  <th className="border border-gray-400 px-2 py-2 text-center font-semibold">
                    Action
                  </th>
                )}
              </tr>
            </thead>

            <tbody>
              {summaryData.map((row, idx) => {
                const mgt1Match = registerData.find(
                  (r) => String(r.folio_no) === String(row.folioNo),
                );

                console.log("mgt1",mgt1Match)

                return (
                  <tr
                    key={idx}
                    // className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}
                  >
                    <td className="border border-gray-400 px-2 py-2  text-center">
                      {idx + 1}
                    </td>
                    <td className="border border-gray-400 px-2 py-2   text-center font-medium">
                      {val(row.folioNo)}
                    </td>
                    <td className="border border-gray-400 px-2 py-2  text-left">
                      {val(row.memberName)}
                    </td>
                    <td className="border border-gray-400 px-2 py-2  text-left">
                      {val(row.jointHolderName)}
                    </td>
                    <td className="border border-gray-400 px-2 py-2 text-right font-medium">
                      {row.numberOfShares != null
                        ? Number(row.numberOfShares).toLocaleString("en-IN")
                        : "-"}
                    </td>

                    {showAction && (
                      <td className="border border-gray-400 px-2 py-1 text-center">
                        <button
                          
                          onClick={() => mgt1Match && onAddShare(mgt1Match)}
                          className="text-xs px-3 py-1 rounded bg-primary text-white disabled:opacity-40 disabled:cursor-not-allowed transition"
                        >
                          + Add share holder
                        </button>
                      </td>
                    )}
                  </tr>
                );
              })}

              <tr className="bg-gray-100 font-semibold">
                <td
                  colSpan={4}
                  className="border border-gray-400 px-2 py-2 text-center"
                >
                  TOTAL NUMBER OF SHARES
                </td>
                <td className="border border-gray-400 px-2 py-2 text-right ">
                  {totalShares.toLocaleString("en-IN")}
                </td>
                {showAction && (
                  <td className="border border-gray-400 px-2 py-2 text-center">
                    —
                  </td>
                )}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ShareSummaryTable;
